<template>
  <div class="card card-top-line">
    <div class="header d-flex align-items-center justify-content-between">
      <h2>Logo Icon</h2>
      <i class="fa fa-edit font-20" @click="editDetails()"></i>
    </div>
    <div class="body" v-if="!logoIcon.readonlyMode">
      <ValidationObserver v-slot="{ passes }">
        <form
          @submit.prevent="passes(logoIconSubmit)"
          id="logo-form"
          ref="form"
        >
          <div class="d-flex logo-icon-area">
            <div class="text-center mb-4">
              <img :src="logoIcon.logo" class="logo-icon" alt="logo" />
            </div>
          </div>
          <div class="media-body" v-if="!logoIcon.readonlyMode">
            <ValidationProvider
              name="logo"
              rules="required"
              v-slot="{ errors }"
            >
              <div
                class="form-group"
                :class="{
                  errors: errors.length && !logoIcon.logo,
                  success: logoIcon.logo,
                }"
              >
                <div class="custom-file">
                  <input
                    type="hidden"
                    name="logo"
                    v-model="logoIcon.logo"
                    accept="image/*"
                  />
                  <input
                    type="file"
                    ref="resetInputFile"
                    id="logoIcon"
                    class="form-control custom-file-input"
                    placeholder="Upload your logo icon*"
                    accept="image/*"
                    @change="logoIconChange"
                  />
                  <label class="custom-file-label" for="logoIcon">
                    Upload your logo icon.*
                  </label>
                  <i
                    class="fa fa-times"
                    v-if="errors.length && !logoIcon.logo"
                  ></i>
                  <i class="fa fa-check" v-if="logoIcon.logo"></i>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div
            v-if="!logoIcon.readonlyMode"
            class="justify-content-center d-flex"
          >
            <b-button
              size="lg"
              @click="logoIcon.readonlyMode = true"
              class="btn-mw"
            >
              Cancel
            </b-button>
            <b-button type="submit" variant="primary ml-1 btn-mw" size="lg">
              Update
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";

export default {
  name: "LogoIcon-Profile",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      logoIcon: {
        logo: require(`@/assets/payangel_logo.png`),
        readonlyMode: true,
      },
    };
  },
  methods: {
    editDetails() {
      this.logoIcon.readonlyMode = false;
    },

    logoIconSubmit() {
      this.logoIcon.readonlyMode = true;
    },

    logoIconChange(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.logoIcon.logo = URL.createObjectURL(file);
      }
    },
  },
};
</script>
